import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NavbarMenu from "./components/NavBar/NavbarMenu";
import ScrollToTopButton from "./components/ScrollToTopButton/ScrollToTopButton";
import HeroSection from "./components/Hero/HeroSection";
import AboutSection from "./components/About/AboutSection";
import EventScheduleSection from "./components/EventSchedule/EventScheduleSection";
import ExhibitorsSection from "./components/Exhibitors/ExhibitorsSection";
import PartnersSection from "./components/Partners/PartnersSection";
import ContactSection from "./components/Contact/ContactSection";
import "./App.css";

function HomeContent() {
  return (
    <div>
      <section id="section1">
        <HeroSection />
      </section>
      <section id="section2">
        <AboutSection />
      </section>
      <section id="section3">
        <EventScheduleSection />
      </section>
      <section id="section4">
        <ExhibitorsSection />
      </section>
      <section id="section5">
        <PartnersSection />
      </section>
      <section id="section7">
        <ContactSection />
      </section>
      <ScrollToTopButton />
    </div>
  );
}

export default function App() {
  return (
    <Router>
      <NavbarMenu />
      <Routes>
        <Route path="/" element={<HomeContent />} />
        <Route path="/about" element={<HomeContent />} />
        <Route path="/schedule" element={<HomeContent />} />
        <Route path="/exhibitors" element={<HomeContent />} />
        <Route path="/partners" element={<HomeContent />} />
        <Route path="/contact" element={<HomeContent />} />
      </Routes>
    </Router>
  );
}
